export const forfaits = [
  {
    name: "Démarrage",
    target: "Vous travaillez seul et votre volume administratif reste limité.",
    hours: "3 h par mois",
    price: "135 €",
    features: ["Traitement de vos courriers et de vos mails", "Devis et factures", "Classement de vos pièces", "Rappel de vos échéances"],
  },
  {
    name: "Essentielle",
    target: "Artisan ou commerçant sans salarié, avec un vrai flux de clients.",
    hours: "7 h par mois",
    price: "300 €",
    features: ["Tout Démarrage", "Gestion administrative courante", "Relance de vos clients en retard de paiement", "Suivi de vos devis en attente"],
  },
  {
    name: "Confort",
    target: "Vous avez 1 à 3 salariés et l'administratif déborde sur vos week-ends.",
    hours: "14 h par mois",
    price: "560 €",
    highlight: true,
    features: ["Tout Essentielle", "Dossiers du personnel et préparation à la paie", "Suivi commercial et fidélisation de vos clients", "Votre espace documentaire, inclus", "La Garantie zéro oubli, incluse"],
  },
  {
    name: "Sérénité",
    target: "4 à 10 salariés. Vous voulez piloter votre activité, pas la gérer.",
    hours: "28 h par mois",
    price: "1 050 €",
    features: ["Tout Confort", "Achats et relation fournisseurs", "Préparation des éléments comptables", "Tableaux de suivi de votre activité"],
  },
];

export const abonnements = [
  {
    name: "Veille et conformité",
    price: "39 €",
    period: "HT / mois",
    text: "Chaque mois, un mémo court des échéances et des nouveautés qui concernent vraiment votre activité, plus 30 minutes de questions par téléphone.",
  },
  {
    name: "Garantie zéro oubli",
    price: "79 €",
    period: "HT / mois",
    text: "Votre calendrier d'échéances tenu à jour — TVA, URSSAF, DSN, fins de période d'essai, visites médicales, renouvellements — et une relance avant chaque date.",
  },
  {
    name: "Espace documentaire",
    price: "25 €",
    period: "HT / mois",
    text: "Vos documents classés dans un espace sécurisé, accessible à tout moment, depuis votre téléphone comme depuis votre bureau.",
  },
];

export const missions = [
  {
    name: "Remplacement et renfort",
    price: "330 €",
    period: "HT par jour · 1 550 € la semaine",
    text: "Congés, arrêt, pic d'activité, départ non remplacé : je reprends le poste administratif en entier — mails, appels, devis, planning, relation client — le temps qu'il faut.",
  },
  {
    name: "Mise en conformité facture électronique",
    price: "290 €",
    period: "HT, une seule fois",
    text: "Depuis le 1er septembre 2026, vous devez pouvoir recevoir des factures électroniques ; vous devrez les émettre au 1er septembre 2027. Je choisis et raccorde votre plateforme, teste un cycle complet et vous laisse un mémo de deux pages.",
  },
  {
    name: "Pack Créateur",
    price: "350 €",
    period: "HT, une seule fois",
    text: "Vous démarrez votre activité : modèles de devis et de factures conformes, conditions générales de vente, tableau de suivi, calendrier de vos obligations et une heure d'accompagnement.",
  },
  {
    name: "Pack Première embauche",
    price: "290 €",
    period: "HT, une seule fois",
    text: "Vous recrutez pour la première fois : déclaration préalable, trame de contrat, registre du personnel, affichages obligatoires et mise en place du suivi des visites médicales et des périodes d'essai.",
  },
  {
    name: "Mise au propre avant bilan",
    price: "320 €",
    period: "HT par jour · 590 € les deux jours",
    text: "Vos pièces de l'exercice triées et rapprochées, les justificatifs manquants relancés, un dossier complet remis à votre expert-comptable.",
  },
  {
    name: "Relance de vos factures impayées",
    price: "90 €",
    period: "HT / mois",
    text: "Je suis vos échéances clients et relance à votre place, par écrit et par téléphone, avec un point mensuel sur vos encours. Souvent, la première facture récupérée paie la prestation.",
  },
  {
    name: "Préparation à la paie",
    price: "12 €",
    period: "HT par bulletin, minimum 5 bulletins par mois",
    text: "Je collecte et contrôle les variables du mois — heures, absences, primes, arrêts — les transmets à votre gestionnaire de paie et vérifie les bulletins reçus.",
  },
  {
    name: "Suivi du personnel",
    price: "80 €",
    period: "HT / mois, quel que soit l'effectif, jusqu'à 10 salariés",
    text: "Le dossier de chaque salarié tenu à jour et complet : contrats, registre, attestations, visites médicales, congés, documents obligatoires. Vous savez à tout moment où en est chacun.",
    note: "Souscrit avec la Garantie zéro oubli : 140 € HT par mois pour les deux, au lieu de 159 €.",
  },
  {
    name: "Intervention à l'heure",
    price: "50 €",
    period: "HT de l'heure, minimum deux heures",
    text: "Pour tout besoin qui n'entre dans aucune des cases ci-dessus.",
  },
];

export const kits = [
  {
    name: "Kit Admin de l'entrepreneur",
    price: "37 €",
    text: "Classeur de suivi prêt à l'emploi, modèles de courriers et de relances, calendrier annuel de vos obligations et une routine d'une heure par semaine.",
  },
  {
    name: "Kit Première embauche",
    price: "59 €",
    text: "Toutes les trames et les checklists du pack, à remplir vous-même : contrat, déclaration préalable, registre, suivi du salarié.",
  },
  {
    name: "Kit Facture électronique",
    price: "29 €",
    text: "Guide de mise en conformité, comparatif des plateformes, checklist de raccordement et mémo des mentions obligatoires.",
  },
];

export const methode = [
  {
    title: "On se rencontre",
    text: "Un rendez-vous découverte de 30 minutes, offert, pour comprendre votre situation et vérifier que je suis la bonne personne pour vous aider.",
  },
  {
    title: "On fait le point",
    text: "L'audit Clarté, deux heures chez vous, suivi d'un rapport écrit et d'une proposition chiffrée. Vous décidez ensuite, sans pression.",
  },
  {
    title: "On met en route",
    text: "J'installe votre espace documentaire et vos outils, puis le forfait démarre. Dès le premier mois, vous récupérez du temps.",
  },
];

export const bonASavoir = [
  "Une journée d'intervention vaut 7 heures, une demi-journée 3,5 heures.",
  "Le rythme indiqué pour chaque formule est donné à titre indicatif : c'est le volume d'heures mensuel qui compte, et vous l'utilisez comme cela vous arrange.",
  "Les forfaits sont sans engagement de durée, avec un préavis d'un mois.",
  "L'audit offert est acquis au terme de trois mois de forfait. Si vous arrêtez avant, il vous est facturé 150 € sur votre dernière facture : vous restez libre d'arrêter quand vous le souhaitez.",
  "Les heures non utilisées sont reportables sur le mois suivant, dans la limite de 30 % du forfait.",
  "Toute heure au-delà du forfait vous est proposée avant d'être engagée, au tarif de 45 € HT : rien ne vous est facturé sans votre accord écrit.",
  "Les déplacements sont inclus dans un rayon de 10 km autour de Guiche. Au-delà, seuls les kilomètres supplémentaires sont facturés, à 0,50 € du kilomètre aller-retour.",
  "Un engagement de 12 mois donne droit à 3 % de remise, et un règlement annuel d'avance à 3 % également. Les deux se cumulent, sur toutes les formules sans exception.",
  "Les prix sont indiqués hors taxes. TVA 20 % en sus, sauf pour les kits dont le prix est affiché toutes taxes comprises.",
];
